import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '@app/services/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-profile-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile-popup.component.html',
  styleUrls: ['./profile-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilePopupComponent implements OnInit, OnDestroy {
  @Input() show = false;
  @Output() close = new EventEmitter<void>();
  @Output() openPricing = new EventEmitter<void>();
  subscriptionInfo: any;
  userDetails: any;
  private subscription = new Subscription();

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.getProfile();
    this.getSubscriptionDetails();
  }

  getProfile() {
    this.subscription.add(
      this.apiService.getProfile().subscribe(
        (res) => {
          this.userDetails = res;
          this.cdr.markForCheck();
        },
        (err) => { }
      )
    );
  }

  getSubscriptionDetails() {
    this.subscription.add(
      this.apiService.getSubscription().subscribe(
        (res) => {
          this.subscriptionInfo = res;
          this.cdr.markForCheck();
        },
        (err) => { }
      )
    );
  }

  onClose() {
    this.close.emit();
  }

  onSubscribe() {
    this.close.emit();
    this.openPricing.emit();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
} 